import React, { FC } from "react";
import styled from "styled-components";
import { PageTitle } from "../../../components/atoms/pageTitle";
import { ALink } from "../../../components/utility/link";
import { PTextPrimaryM } from "../../../components/utility/textPrimary";
import { PTextSecondaryM } from "../../../components/utility/textSecondary";
import { DivWrap } from "../../../components/utility/wrap";
import { MARUTSUKE_CORPORATE_WEBSITE_URL } from "../../../config/Constants";

export const PrivacyPolicy:FC = () => {

  return(
    <DivWrap>
      <PageTitle text={'プライバシーポリシー'}/>
      <DivSectioin>
        <PTextPrimaryM>「株式会社Marutsuke」（以下「当社」といいます。）は、当社の提供するサービス（以下「本サービス」といいます。）における、ユーザーについての個人情報を含む利用者情報の取扱いについて、以下のとおりプライバシーポリシー（以下「本ポリシー」といいます。）を定めます。</PTextPrimaryM>
      </DivSectioin>
      <DivSectioin>
        <H2SectionTitle>1.収集する利用者情報及び収集方法</H2SectionTitle>
        <DivHeadWrap>本ポリシーにおいて、「利用者情報」とは、ユーザーの識別に係る情報、通信サービス上の行動履歴、その他ユーザーまたはユーザーの端末に関連して生成または蓄積された情報であって、本ポリシーに基づき当社が収集するものを意味するものとします。本サービスにおいて当社が収集する利用者情報は、その収集方法に応じて、以下のようなものとなります。</DivHeadWrap>
        <DivListWrap>
          <DivListOrder>1.</DivListOrder>
          <PTextPrimaryM>ユーザーからご提供いただく情報本サービスを利用するために、または本サービスの利用を通じてユーザーからご提供いただく情報は以下のとおりです。・氏名、学年等プロフィールに関する情報・メールアドレス・クレジットカード情報、電子マネー情報等決済手段に関する情報・ユーザーの肖像を含む静止画情報・公式LINEを通じて送信された画像データやテキスト内容（算数プリントの画像など）・入力フォームその他当社が定める方法を通じてユーザーが入力または送信する情報</PTextPrimaryM>
        </DivListWrap>
        <DivListWrap>
          <DivListOrder>2.</DivListOrder>
          <PTextPrimaryM>ユーザーが本サービスの利用において、他のサービスと連携を許可することにより、当該他のサービスからご提供いただく情報</PTextPrimaryM>
        </DivListWrap>
        <DivListWrap>
          <DivListOrder>3.</DivListOrder>
          <PTextPrimaryM>ユーザーが本サービスを利用するにあたって、当社が収集する情報当社は、本サービスへのアクセス状況やそのご利用方法に関する情報を収集することがあります。これには以下の情報が含まれます。・リファラ・IPアドレス・サーバーアクセスログに関する情報・Cookie、ADID、IDFAその他の識別子</PTextPrimaryM>
        </DivListWrap>
      </DivSectioin>
      <DivSectioin>
        <H2SectionTitle>2.利用目的</H2SectionTitle>
        <DivHeadWrap>
          <DivHeadWrap>本サービスのサービス提供にかかわる利用者情報の具体的な利用目的は以下のとおりです。</DivHeadWrap>
        </DivHeadWrap>
        <DivListWrap>
          <DivListOrder>1.</DivListOrder>
          <PTextPrimaryM>本サービスに関する登録の受付、本人確認、ユーザー認証、ユーザー設定の記録、利用料金の決済計算等本サービスの提供、維持、保護及び改善のため</PTextPrimaryM>
        </DivListWrap>
        <DivListWrap>
          <DivListOrder>2.</DivListOrder>
          <PTextPrimaryM>ユーザーのトラフィック測定及び行動測定のため</PTextPrimaryM>
        </DivListWrap>
        <DivListWrap>
          <DivListOrder>3.</DivListOrder>
          <PTextPrimaryM>広告の配信、表示及び効果測定のため</PTextPrimaryM>
        </DivListWrap>
        <DivListWrap>
          <DivListOrder>4.</DivListOrder>
          <PTextPrimaryM>本サービスに関するご案内、お問い合わせ等への対応のため</PTextPrimaryM>
        </DivListWrap>
        <DivListWrap>
          <DivListOrder>5.</DivListOrder>
          <PTextPrimaryM>本サービスに関する当社の規約、ポリシー等（以下「規約等」といいます。）に違反する行為に対する対応のため</PTextPrimaryM>
        </DivListWrap>
        <DivListWrap>
          <DivListOrder>6.</DivListOrder>
          <PTextPrimaryM>本サービスに関する規約等の変更などを通知するため</PTextPrimaryM>
        </DivListWrap>
        <DivListWrap>
          <DivListOrder>7.</DivListOrder>
          <PTextPrimaryM>ユーザーが提出した画像データや入力情報をもとに、外部のAIサービス（OpenAI API等）を通じた自動解析・添削コメントの生成を行い、ユーザーへのフィードバックを提供するため。ただし、当該AIサービスはAPI経由で利用され、AIモデルの学習には一切使用されません。</PTextPrimaryM>
        </DivListWrap>
      </DivSectioin>
      <DivSectioin>
        <H2SectionTitle>3.利用中止要請の方法</H2SectionTitle>
        <DivHeadWrap>ユーザーは、本サービスの所定の設定を行うことにより、利用者情報の全部または一部についてその収集又は利用の停止を求めることができ、この場合、当社は速やかに、当社の定めるところに従い、その利用を停止します。なお利用者情報の項目によっては、その収集または利用が本サービスの前提となるため、当社所定の方法により本サービスを退会した場合に限り、当社はその収集又は利用を停止します。</DivHeadWrap>
      </DivSectioin>
      <DivSectioin>
        <H2SectionTitle>4. 個人を特定しない属性情報・行動履歴の取得及び利用について</H2SectionTitle>
        <DivHeadWrap>当サイトでは、当サイトのアクセス状況を把握するために、Google社の提供するサービスであるGoogle アナリティクスを利用しています。Google アナリティクスはアクセス情報の収集のためにCookieを使用しています。このアクセス情報は匿名で収集されており、個人を特定するものではありません。</DivHeadWrap>
        <ALink href={'https://www.google.com/analytics/terms/jp.html'} target='_blank' rel='oreferrer noopener'>Google アナリティクス利用規約Google プライバシーポリシー<i className="fas fa-external-link-alt"/></ALink>
        <PTextPrimaryM>Google アナリティクスによる情報収集を無効化したい場合は、Google社が提供する「Google アナリティクス オプトアウト アドオン」からオプトアウトの設定をすることで実施可能です。</PTextPrimaryM>
        <DivWrap><ALink href={'https://tools.google.com/dlpage/gaoptout?hl=ja'} target='_blank' rel='oreferrer noopener'>Google アナリティクス オプトアウト アドオン<i className="fas fa-external-link-alt"/></ALink></DivWrap>
      </DivSectioin>
      <DivSectioin>
        <H2SectionTitle>5. 第三者提供</H2SectionTitle>
        <DivHeadWrap>当社は、利用者情報のうち、個人情報については、あらかじめユーザーの同意を得ないで、第三者（日本国外にある者を含みます。）に提供しません。但し、次に掲げる必要があり第三者（日本国外にある者を含みます。）に提供する場合はこの限りではありません。</DivHeadWrap>
        <DivListWrap>
          <DivListOrder>1.</DivListOrder>
          <PTextPrimaryM>当社が利用目的の達成に必要な範囲内において個人情報の取扱いの全部または一部を委託する場合</PTextPrimaryM>
        </DivListWrap>
        <DivListWrap>
          <DivListOrder>2.</DivListOrder>
          <PTextPrimaryM>合併その他の事由による事業の承継に伴って個人情報が提供される場合</PTextPrimaryM>
        </DivListWrap>
        <DivListWrap>
          <DivListOrder>3.</DivListOrder>
          <PTextPrimaryM>第4項の定めに従って、提携先または情報収集モジュール提供者へ個人情報が提供される場合</PTextPrimaryM>
        </DivListWrap>
        <DivListWrap>
          <DivListOrder>4.</DivListOrder>
          <PTextPrimaryM>国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、ユーザーの同意を得ることによって当該事務の遂行に支障を及ぼすおそれがある場合</PTextPrimaryM>
        </DivListWrap>
        <DivListWrap>
          <DivListOrder>5.</DivListOrder>
          <PTextPrimaryM>その他、個人情報の保護に関する法律（以下「個人情報保護法」といいます。）その他の法令で認められる場合</PTextPrimaryM>
        </DivListWrap>
      </DivSectioin>
      <DivSectioin>
        <H2SectionTitle>6.個人情報の開示</H2SectionTitle>
        <DivHeadWrap>当社は、ユーザーから、個人情報保護法の定めに基づき個人情報の開示を求められたときは、ユーザーご本人からのご請求であることを確認の上で、ユーザーに対し、遅滞なく開示を行います（当該個人情報が存在しないときにはその旨を通知いたします。）。但し、個人情報保護法その他の法令により、当社が開示の義務を負わない場合は、この限りではありません。なお、個人情報の開示につきましては、手数料（1件あたり1,000円）を頂戴しておりますので、あらかじめ御了承ください。</DivHeadWrap>
      </DivSectioin>
      <DivSectioin>
        <H2SectionTitle>7.個人情報の訂正及び利用停止等</H2SectionTitle>
        <DivListWrap>
          <DivListOrder>1.</DivListOrder>
          <PTextPrimaryM>当社は、ユーザーから、(1)個人情報が真実でないという理由によって個人情報保護法の定めに基づきその内容の訂正を求められた場合、及び(2)あらかじめ公表された利用目的の範囲を超えて取扱われているという理由または偽りその他不正の手段により収集されたものであるという理由により、個人情報保護法の定めに基づきその利用の停止を求められた場合には、ユーザーご本人からのご請求であることを確認の上で遅滞なく必要な調査を行い、その結果に基づき、個人情報の内容の訂正または利用停止を行い、その旨をユーザーに通知します。なお、訂正または利用停止を行わない旨の決定をしたときは、ユーザーに対しその旨を通知いたします。</PTextPrimaryM>
        </DivListWrap>
        <DivListWrap>
          <DivListOrder>2.</DivListOrder>
          <PTextPrimaryM>当社は、ユーザーから、ユーザーの個人情報について消去を求められた場合、当社が当該請求に応じる必要があると判断した場合は、ユーザーご本人からのご請求であることを確認の上で、個人情報の消去を行い、その旨をユーザーに通知します。</PTextPrimaryM>
        </DivListWrap>
        <DivListWrap>
          <DivListOrder>3.</DivListOrder>
          <PTextPrimaryM>個人情報保護法その他の法令により、当社が訂正等または利用停止等の義務を負わない場合は、7項1および7項2の規定は適用されません。</PTextPrimaryM>
        </DivListWrap>
      </DivSectioin>
      <DivSectioin>
        <H2SectionTitle>8.お問い合わせ</H2SectionTitle>
        <DivHeadWrap>
          <PTextPrimaryM>メールアドレス: drill.sansu.com@gmail.com</PTextPrimaryM>
          <PTextPrimaryM>Twitterアカウント: https://twitter.com/drill_sansu</PTextPrimaryM>
        </DivHeadWrap>
      </DivSectioin>
      <DivSectioin>
        <H2SectionTitle>9. プライバシーポリシーの変更手続</H2SectionTitle>
        <DivHeadWrap>当社は、必要に応じて、本ポリシーを変更します。但し、法令上ユーザーの同意が必要となるような本ポリシーの変更を行う場合、変更後の本ポリシーは、当社所定の方法で変更に同意したユーザーに対してのみ適用されるものとします。なお、当社は、本ポリシーを変更する場合には、変更後の本ポリシーの施行時期及び内容を当社のウェブサイト上での表示その他の適切な方法により周知し、またはユーザーに通知します。</DivHeadWrap>
      </DivSectioin>
      <DivSectioin>
        <PTextPrimaryM>【2025年6月14日改定】</PTextPrimaryM>
        <PTextPrimaryM>【2024年8月24日改定】</PTextPrimaryM>
        <PTextPrimaryM>【2022年3月8日改定】</PTextPrimaryM>
        <PTextPrimaryM>【2022年1月30日制定】</PTextPrimaryM>
      </DivSectioin>
      <DivWrap style={{padding: '0.5rem 1rem', textAlign: 'right'}}>
        <ALink href={'/legal/terms'}>利用規約</ALink>
      </DivWrap>
      <DivWrap style={{padding: '0.5rem 1rem 1rem', textAlign: 'right'}}>
        <ALink href={'/legal/specified_commercial_transaction_act'}>特定商取引法に基づく表記</ALink>
      </DivWrap>
      <DivWrap style={{padding: '0 1rem 3rem 0', textAlign: 'right'}}>
        <ALink href={MARUTSUKE_CORPORATE_WEBSITE_URL} target="_blank">運営会社<i className="fas fa-external-link-alt"></i></ALink>
      </DivWrap>
      <DivWrap style={{padding: '0 1rem 3rem 0', textAlign: 'right'}}>
        <ALink href={'/top'}>トップへ</ALink>
      </DivWrap>
    </DivWrap>
  )
}

const DivSectioin = styled.div`
  padding: 1.5rem 1rem;
`

const H2SectionTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 1rem;
`

const DivListWrap = styled.div`
  display: flex;
  margin: 1rem 0;
`
const DivListWrapSmall = styled.div`
  display: flex;
  margin: 0.5rem 0;
`
const DivListOrder = styled.div`
  font-size: 1rem;
  margin-right: 0.5rem;
`

const DivHeadWrap = styled.div`
  margin: 1rem 0;
`
